module.exports = __webpack_public_path__ + "static/background.cca532c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/background.jpg
// module id = 481
// module chunks = 75105661925852